import {
  getTutorialStepsForRole,
  getRoleTutorialLabel,
  type TutorialStep,
} from "../Constants/tutorialSteps";
import { filterTutorialStepsByCapabilities } from "../Constants/tutorialCapabilityGates";
import { USER_ROLE } from "../Types/user";

const COMPLETED_KEY_PREFIX = "intentico:tutorialCompleted:";

export function tutorialCompletedStorageKey(userId: string): string {
  return `${COMPLETED_KEY_PREFIX}${userId}`;
}

export function hasCompletedTutorial(userId: string | null | undefined): boolean {
  if (!userId) return true;
  try {
    return localStorage.getItem(tutorialCompletedStorageKey(userId)) === "1";
  } catch {
    return false;
  }
}

export function markTutorialCompleted(userId: string): void {
  try {
    localStorage.setItem(tutorialCompletedStorageKey(userId), "1");
  } catch {
    /* ignore storage errors */
  }
}

export function clearTutorialCompleted(userId: string): void {
  try {
    localStorage.removeItem(tutorialCompletedStorageKey(userId));
  } catch {
    /* ignore storage errors */
  }
}

export type ResolveTutorialStepsOptions = {
  /**
   * Platform admins (no client_id) — skip capability gates.
   * When capabilities are null/undefined and ungated is false, role steps are
   * returned unfiltered so the guide still works while status is loading.
   */
  ungated?: boolean;
  capabilities?: Record<string, boolean> | null;
};

export function resolveTutorialSteps(
  role: USER_ROLE | null | undefined,
  options?: ResolveTutorialStepsOptions
): TutorialStep[] {
  if (!role) return [];
  const roleSteps = getTutorialStepsForRole(role);
  return filterTutorialStepsByCapabilities(roleSteps, options?.capabilities, {
    ungated: options?.ungated,
  });
}

export { getRoleTutorialLabel };
